const HealEvent = function (battleState, actor, potency) {
  this.eventHandle = 'heal';

  if (!actor) {
    this.execute = () => {};
    return;
  }

  this.actorId = actor.uid;
  this.potency = potency;

  this.execute = (victim) => {
    this.victimId = victim.uid;

    this.affectedPieces = [victim];
    victim.hp = Math.min(victim.max_hp, victim.hp + potency);

    battleState.onBattleEvent(this);
  };
};
module.exports = HealEvent;
